import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { RootineFooter } from '../components';
import { useGlobalState } from '../utils/GlobalStateProvider';

export const ReferFriend = (): JSX.Element => {
  const context = useGlobalState(true);
  useEffect(() => {
    // @ts-ignore: any type
    window['friendbuy'] = window['friendbuy'] || [];
    // @ts-ignore: any type
    window['friendbuy'].push(['widget', 'eR4-uDH']);
  }, []);
  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={4}
        rowSpacing={2}
        sx={{
          px: { xs: 2, md: 10 },
          marginTop: { xs: 10, md: 10 },
        }}
      >
        <Grid item xs={12}>
          <div className="friendbuy-eR4-uDH"></div>
          <RootineFooter />
        </Grid>
      </Grid>
    </>
  );
};
